export default {
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    async handleBiometryCameraSuccess(payload) {
      const { encrypted } = payload;

      try {
        this.loadSituation();
        const data = await this.saveFace({ selfie: encrypted });
        const { ImagemAceita, MensagemErro, Protocolo } = data;

        if (!!ImagemAceita && !MensagemErro && !!Protocolo) {
          this.showSucessfullyRegistereBiometryModal = true;
          this.alreadyRegistered = true;
          this.justRegisteredProtocol = Protocolo;
          this.timer = setInterval(() => this.loadSituation(), 1000);
          await this.$root.$emit("hide-loading");
          return;
        }

        this.quitLoadSituationProcess();
        this.$toast({
          description: MensagemErro ?? "Ocorreu um erro ao salvar a biometria",
          status: "error",
          duration: 10000,
          position: "top"
        });
      } catch (error) {
        this.quitLoadSituationProcess();
        this.handleError(error);
      }
    },
    quitLoadSituationProcess() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.process = null;
    },
    initLoadSituationProcess() {
      this.process = {
        step: 1,
        title: "Validando biometria...",
        description: "Por favor, aguarde. Esta etapa pode levar até 15 segundos."
      };
    },
    updateLoadSituationMessage() {
      if (this.process.step !== 7) return;
      this.process = {
        step: 7,
        title: "Validando biometria...",
        description: "Por favor, aguarde. Estamos concluindo a validação."
      };
    },
    stopTimerOnTimeout() {
      if (this.process.step >= 15 && this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async loadSituation() {
      if (this.process === null) {
        this.initLoadSituationProcess();
        return;
      }
      if (this.process.step > 15) {
        this.finishLoadSituation(this.loadSituationTimeoutModal);
        return;
      }
      this.process.step++;
      if (this.process.step % 5 !== 0) {
        this.updateLoadSituationMessage();
        return;
      }
      try {
        this.stopTimerOnTimeout();
        this.handleFaceStatus(await this.fetchFaceStatus());
      } catch (error) {
        if (this.handleLoadSituationError) {
          this.handleLoadSituationError(error);
          return;
        }
        this.handleError(error);
      }
    }
  }
};
